import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { RolesService } from '../services/roles.service';

const ROLES_PERMITIDOS = [
  'Usuarios.Administrador',
  'Usuarios.Titular',
  'Usuarios.TitularJER',
  'Usuarios.Consulta',
];

export const appAccessGuard = () => {
  const rolesService = inject(RolesService);
  const router = inject(Router);

  if (rolesService.hasAnyRole(ROLES_PERMITIDOS)) {
    return true;
  }

  return router.createUrlTree(['/auth/login']);
};
